import { memo, ReactNode, useMemo } from "react";

import "./index.scss"

export type Button = {
  label: string | ReactNode
  classes?: string[]
  type?: 'primary' | 'secondary' | 'tertiary' | 'ghost'
  size?: 'l' | 'm' | 's'
  onClick: (e: MouseEvent) => void
  isActive?: boolean
}

const Button = memo(({
  label, classes = [], type = 'primary', size = 'l', onClick = () => {},
  isActive = false
}: Button) => {
  const classNames = useMemo(() => {
    const classArr: string[] = ['Button', type, `size-${size}`]
    if (classes.length) classArr.concat(classes)
    if (isActive) classArr.push('active')

    return classArr.join(' ')
  }, [classes])

  return (
    <button
      className={classNames}
      tabIndex={0}
      type="button"
      onClick={onClick}
    >
      {label}
    </button>
  )
})

export default Button
